module.exports = __webpack_public_path__ + "static/media/plus_white.08cc66de.svg";